const moduloAutoconsumo = {
  agGrid: {
    paginacion: 15,
    id: 'myGrid',
    // class: 'ag-theme-material mt-3',
    class: 'ag-theme-alpine',
    style: {
      width: '100%',
      height: '400px'
    }
  },
  tipoImputacionArray: [
    {
      id: 0,
      descripcion: 'ELEMENTO PEP'
    },
    {
      id: 1,
      descripcion: 'ORDEN INTERNA CO'
    },
    {
      id: 2,
      descripcion: 'CENTRO COSTO'
    },

  ],
  url: {
    autoconsumo: {
      mantenedor: {
        creacion: 'autocon-parametro/crear',
        validarCliente: 'autocon-parametro/validarClienteVentaAmpliado',
        getByCliente: 'autocon-parametro/',
        getAll: 'autocon-parametro',
      },
      motivoPedido: {
        creacion: 'autocon-motivo-pedido/crear',
        actualizar: 'autocon-motivo-pedido/actualizarMotivo',
        getAll: 'autocon-motivo-pedido',
        delete: 'autocon-motivo-pedido/eliminar?id=',
      },
      mantenedorSolicitudPedidoVenta: {
        creacion: 'autocon-pedido-cabecera/crear',
        creacionCompleta: 'autocon-pedido-cabecera/completeCrear',
        actualizacion: 'autocon-pedido-cabecera/crear',
        actualizacionCompleta: 'autocon-pedido-cabecera/completeActualizar',
        getAll: 'autocon-pedido-cabecera',
        getAlltoAprove: 'autocon-pedido-cabecera/pending',
        getByOficinaVenta: 'autocon-pedido-cabecera/oficina-venta/',
        delete: 'autocon-pedido-cabecera/eliminar?idPedido=',
        getAllGerenciasByToken: 'autocon-pedido-cabecera/get-gerencias',
      },
      aprobacionPedidoVenta: {
        update: 'autocon-pedido-aprob/update',
        getGerenciaAprobByUserToken: 'autocon-pedido-aprob/allGerenciasByUser'
      }
    },
  },
  button: {
    buttonsCss: {
      primary: 'btn btn-primary btn-block',
      secondary: 'btn btn-secondary btn-block',
      success: 'btn btn-success btn-block',
      danger: 'btn btn-danger btn-block',
      warning: 'btn btn-warning btn-block',
      info: 'btn btn-info btn-block',
      light: 'btn btn-light btn-block',
      dark: 'btn btn-dark btn-block',

      primaryOutline: 'btn btn-outline-primary btn-block',
      secondaryOutline: 'btn btn-outline-secondary btn-block',
      successOutline: 'btn btn-outline-success btn-block',
      dangerOutline: 'btn btn-outline-danger btn-block',
      warningOutline: 'btn btn-outline-warning btn-block',
      infoOutline: 'btn btn-outline-info btn-block',
      lightOutline: 'btn btn-outline-light btn-block',
      darkOutline: 'btn btn-outline-dark btn-block'
    },
    buttonsNombre: {
      //*GLOBAL
      editar: 'Editar',
      eliminar: 'Eliminar',
      aprobar: 'Aprobar',
      nuevo: 'Nuevo',
      agregar: 'Agregar',
      solicitarAprobacion: 'Solicitar Aprobación',

      //*SECCION DE MENU
      agregarN2: 'Agregar Nivel 2',
      agregarN3: 'Agregar Nivel 3',
      agregarRol: 'Agregar Rol',
      agregarSolicitudPedido: 'Agregar Solicitud de Pedido',
      agregarFeriado: 'Agregar Feriado',
      agregarPorcentajeRecarga: 'Agregar Porcentaje de Recarga',
      agregarEmpleado: 'Agregar Parámetro de Empleado',
      agregarFechaCorte: 'Agregar Fecha de Corte',
      agregarTurno: 'Agregar Turnos',
      agregarMinutosGracia: 'Agregar Minutos de Gracia',
      agregarLocalidadTurno: 'Agregar Localidad Turno',
      agregarReemplazoEmpleado: 'Agregar Reemplazo Empleado',

      agregarEstado: 'Agregar Estado',
      agregarSesion: 'Agregar Sesión',
      agregarUsuario: 'Agregar Usuario',
      agregarMaterial: 'Agg Material',
      agregarPortafolio: 'Agregar Portafolio',
      agregarAutorizacion: 'Agregar Autorización',
      agregarAplicacion: 'Agregar Aplicación',

      agregarCampo: 'Agregar',
      guardar: 'Guardar',
      mostrar: 'Mostrar seleccion',
      regresar: 'Regresar',
      continuar: 'Continuar',
      buscar: 'Buscar',
      procesar: 'Procesar',
      rechazar: 'Rechazar',
      Ver: 'Ver',
    }
  },
  mensajes: {
    eliminar: '¿Esta seguro que desea eliminar el siguiente elemento?',
    solicitarAprobacion: '¿Esta seguro que desea confirmar el siguiente elemento?',
    solicitarRechazo: '¿Esta seguro que desea rechazar el siguiente elemento?',
    guardar: '¿Esta seguro que desea guardar el siguiente elemento?',
    actualizar: '¿Esta seguro que desea actualizar el siguiente elemento?',
    datoGuardado: 'Se guardo corectamente..!!',
    completeInformacion: 'Complete la informacion requerida',
    mensajeAdvertencia: 'La Órden contiene un solo elemento en el detalle desea eliminar la órden completa?',
    guardarDatorForm: 'Desea guardar los datos del formulario',
    mjsProcesar: 'Desea procesar los datos del formulario',
    mjsCampo: 'Al menos debe contener otro Campo "Articulo Alternativo"',
    mjsCampo1: 'Al menos debe contener otro Campo "CodigoBarra"',
    mjsCampo2: 'Al menos debe contener otro Campo',
    mjsCampoAdv: 'Obligatorio Campo Cantidad',
    mjsFilasCorrectas: 'Filas Correctas',
    mjsFilasIncorrectas: 'Filas Incorrectas',
    procesar: '¿Esta seguro que desea procesar el siguiente formulario?',
    getSumaPorcentajesErrorMessage: 'La suma de porcentajes no puede exceder el 100%',
    getInvalidPorcentajeErrorMessage: 'El porcentaje es inválido',
    getOutOfRangeErrorMessage: 'El valor está fuera del rango permitido',
  },
  titulos: {
    autoconsumoCreacionMantenedor: {
      titulo: 'Parámetros Autoconsumo',
      modulo: 'Autoconsumo',
      tituloCardListar: 'Listar Parámetros',
      tituloCardGuardar: 'Guardar Parámetros',
      tituloCardEditar: 'Editar Parámetros',
    },
    autoconsumoMotivoPedido: {
      titulo: 'Parámetros Motivos de Pedidos',
      modulo: 'Autoconsumo',
      tituloCardListar: 'Parámetros Motivos de Pedidos',
      tituloCardGuardar: 'Guardar Motivo de Pedido',
      tituloCardEditar: 'Editar Motivo de Pedido',
    },
    mantenedorSolicitudPedidoVenta: {
      titulo: 'Mantenedor Solicitud Pedido Venta',
      modulo: 'Autoconsumo',
      tituloCardListar: 'Listar Solicitudes de Pedido Venta',
      tituloCardGuardar: 'Guardar Solicitud de Pedido Venta Autoconsumo',
      tituloCardEditar: 'Editar Solicitud de Pedido Venta',
    },
    mantenedorGestorPedidoVenta: {
      titulo: 'Gestor Solicitud Pedido Venta',
      modulo: 'Autoconsumo',
      tituloCardListar: 'Listar Solicitudes de Pedido Venta',
      tituloCardGuardar: 'Visualizar Solicitud de Pedido Venta Autoconsumo',
      tituloCardEditar: 'Visualizar Solicitud de Pedido Venta',
    }
  }
}
export {moduloAutoconsumo}
